import { useEffect } from "react";
import ApplicationCooLayout from "../../layout/application-coo-layout";
import { TextSubheader } from "../../components/text/text-subheader";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../redux/hook";
import { P2Alert, P2Button } from "react-bootstrap-common-script";
import { Separator } from "../../components/separator";
import ReviewingIcon from "../../assets/svg/reviewing-icon";
import { useInitialWindowScrollTo } from "../../hooks/use-initial-window-scroll-to";
import { useCallback } from "react";
import { stageCTrackingId } from "../../utils/wogaa-ids";
import { customWindow } from "../../models/interfaces/wogaa.interface";

const StageCUnsuccessful = () => {
  const startApplicationFormData = useAppSelector((state) => state.app.ApplicationStartSlice.formData);
  let navigate = useNavigate();
  const applicationId = useAppSelector( (state) => state.app.ApplicationIdSlice.applicationId);

  const continuePayment = useCallback(() => {
    navigate(`/application-coo?application_id=${applicationId}`);
  },[applicationId, navigate])

  useInitialWindowScrollTo();
  
  useEffect(() => {
    if (customWindow.wogaaCustom) {
      console.log('completing wogaa transaction')
      customWindow.wogaaCustom.completeTransactionalService(stageCTrackingId);
    }
  }, [customWindow.wogaaCustom]);

  useEffect(() => {
    if(!applicationId){
      window.location.href = "/transfer/dashboard";
    }
  }, [applicationId])

  return (
    <ApplicationCooLayout>
      <div style={{ padding: "41px 41px 44px 40px" }}>
        <TextSubheader
          subheaderMain="Stage C: Make Payment"
          subheaderSub={startApplicationFormData.selected_hdb_property?.address}
        />
        <div className="polymer-unsuccess-container">
          <P2Alert withCTA={false} variant="danger" text={`Sorry, the payment cannot be processed now. Please try again later.`} />
        </div>
        <Separator />
        <div className="polymer-unsuccess-button-group polymer-button-wrapper">
          <P2Button variant={"primary-1"} onClick={continuePayment}>
            Retry
          </P2Button>
        </div>
      </div>
    </ApplicationCooLayout>
  );
};
export default StageCUnsuccessful;
